/* eslint-disable no-unused-vars */

// eslint-disable-next-line typescript-enum/no-enum
export enum LocalStorageKeys {
  AuthToken = 'AuthToken',
  SidebarState = 'SidebarState',
  UserLang = 'UserLang',
}
